import React from 'react';

const Telephone = () => {
    return (
        <div>
            <a href="tel:0613216178" className="telephone_contact"><i className="uil uil-phone"></i>&nbsp;&nbsp;06 13 21 61 78</a>
        </div>
    );
};

export default Telephone;